import React, { useEffect, useState } from "react";
import "../findCustomer/findCustomer.scss";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { ToastContainer, toast } from "react-toastify";
import Spinner from "../common/spinner";
import { log, timestampToDateYearFormat } from "../../helper/helper";
import * as service from "./failedTransferPaymentService";
import "./failedTransferPayment.scss";

import ridingImage from "../../assets/riding.png";
import walkingImage from "../../assets/walking.png";
import cyclingImage from "../../assets/cycling.png";
import drivingImage from "../../assets/driving.png";
import { Button } from "antd";

function FailedTransferPayment(props) {
  const [isLoading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [isBtnShow, setBtnShow] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [cursorTransportId, setCursorTransportId] = useState("");
  const [selectedPay, setSelectedPay] = useState(0.0);

  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (!user) {
        return props.history.replace("/login");
      }
    });

    getAllFailedStripeTransfer("");
  }, []);

  const handleCheckboxChange = (id, isChecked, amount) => {
    setSelectedIds((prev) => {
      if (isChecked) {
        return [...prev, id];
      } else {
        return prev.filter((selectedId) => selectedId !== id);
      }
    });

    setSelectedPay((prev) => {
      const numericPrev = Number(prev) || 0;
      const numericAmount = Number(amount) || 0;
      return isChecked
        ? (numericPrev + numericAmount).toFixed(2)
        : (numericPrev - numericAmount).toFixed(2);
    });
  };

  const handleSelectedTransport = async () => {
    setLoading(true);
    try {
      const result = await service.stripeTransferForTansports(selectedIds);
      setLoading(false);
      log(result);
      if (result) {
        switch (result.data.code) {
          case 200:
            setSelectedPay(0);
            setSelectedIds([]);
            setList([]);
            getAllFailedStripeTransfer("");
            break;
          case 401:
            return props.history.replace("/login");
          case 500:
            return toast.error(result.data.message);
          default:
            return toast.error(result.data.message);
        }
      }
    } catch (error) {
      log(error);
      toast.error(error.message);
      setLoading(false);
    }
  };

  const handleTransportStatus = (status) => {
    switch (status) {
      case "Canceled by Customer":
        return (
          <div className="deleted">
            <span>Canceled by Customer</span>{" "}
          </div>
        );
      case "Canceled by Rider":
        return (
          <div className="rider-deleted">
            <span>Canceled by Rider</span>{" "}
          </div>
        );
      case "Completed":
        return (
          <div className="active mar0">
            <span>Completed</span>{" "}
          </div>
        );
      default:
        return <span>{status}</span>;
    }
  };

  const getAllFailedStripeTransfer = async (value) => {
    setLoading(true);
    try {
      const result = await service.getFailedStripeTransfer(value);
      setLoading(false);
      log(result);
      if (result) {
        switch (result.data.code) {
          case 200:
            setList((prevCoupons) => [
              ...prevCoupons,
              ...result.data.transportList,
            ]);
            if (result.data.cursor_transport_id) {
              setBtnShow(true);
              setCursorTransportId(result.data.cursor_transport_id);
            } else {
              setCursorTransportId("");
              setBtnShow(false);
            }
            break;
          case 401:
            return props.history.replace("/login");
          case 500:
            return toast.error(result.data.message);
          default:
            return toast.error(result.data.message);
        }
      }
    } catch (error) {
      log(error);
      toast.error(error.message);
      setLoading(false);
    }
  };

  const handleBearerType = (bearer) => {
    switch (bearer) {
      case "driving":
        return (
          <div className="bearer">
            <img src={drivingImage} alt="rider" />
          </div>
        );
      case "riding":
        return (
          <div className="bearer">
            <img src={ridingImage} alt="rider" />
          </div>
        );
      case "cycling":
        return (
          <div className="bearer">
            <img src={cyclingImage} alt="cycle" />
          </div>
        );
      case "walking":
        return (
          <div className="bearer">
            <img src={walkingImage} alt="walk" />
          </div>
        );

      default:
        break;
    }
  };

  const renderSpinner = () => {
    if (isLoading) {
      return <Spinner />;
    }
  };

  const handleSelectAll = () => {
    if (selectedIds.length === list.length) {
      setSelectedIds([]);
    } else {
      setSelectedIds(list.map((item) => item.transport_id));
    }
  };

  return (
    <div className="show-all-list failed-transfer-payment">
      <ToastContainer />
      {renderSpinner()}
      <div className="headline">
        <h3>Failed Transfer Payment</h3>
      </div>
      {selectedPay > 0 && (
        <div
          className="payment-selected"
          style={{
            marginBottom: 45,
          }}
        >
          <span
            style={{
              backgroundColor: "#11cb60",
              color: "#FFF",
              padding: "20px 10px",
              borderRadius: 18,
            }}
          >
            Selected to Pay: {selectedPay}
          </span>
        </div>
      )}
      {list && list.length > 0 && (
        <>
          <table className="table">
            <thead>
              <tr>
                <th>Transport Date</th>
                <th>Rider's Name</th>
                <th>Original Payable</th>
                <th>Final Paid</th>
                <th>Mode of Transport</th>
                <th>State</th>
                <th>
                  <Button onClick={handleSelectAll}>
                    {selectedIds.length === list.length
                      ? "Deselect All"
                      : "Select All"}
                  </Button>
                </th>
              </tr>
            </thead>
            <tbody>
              {list.map((list) => (
                <tr key={list.transport_id}>
                  <td>
                    {timestampToDateYearFormat(
                      list.time._seconds,
                      list.time._nanoseconds
                    )}
                  </td>
                  <td>{list.rider_given_name + " " + list.rider_last_name}</td>
                  <td>{list.original_payable_to_rider}</td>
                  <td>{list.final_paid_to_rider}</td>
                  <td>{handleBearerType(list.bearer_type)}</td>
                  <td>{handleTransportStatus(list.transport_state)}</td>
                  <td style={{ width: 100 }}>
                    <input
                      style={{ width: 20, height: 20 }}
                      type="checkbox"
                      checked={selectedIds.includes(list.transport_id)}
                      onChange={(e) =>
                        handleCheckboxChange(
                          list.transport_id,
                          e.target.checked,
                          list.final_paid_to_rider
                        )
                      }
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="load-more">
            <ul style={{ padding: 0, margin: 0 }}>
              {isBtnShow && (
                <li>
                  <button
                    onClick={() =>
                      getAllFailedStripeTransfer(cursorTransportId)
                    }
                  >
                    Load More
                  </button>
                </li>
              )}
              <li>
                <button onClick={handleSelectedTransport}>
                  Transfer Selected Transport
                </button>
              </li>
            </ul>
          </div>
        </>
      )}
    </div>
  );
}
export default FailedTransferPayment;
